import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { MailX, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnsubscribePage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const res = await axios.get(`${API}/unsubscribe/${token}`);
        setInfo(res.data);
        if (res.data.already_unsubscribed) setDone(true);
      } catch {
        setError('Invalid or expired unsubscribe link.');
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, [token]);

  const handleUnsubscribe = async () => {
    try {
      await axios.post(`${API}/unsubscribe/${token}`);
      setDone(true);
    } catch {
      setError('Failed to unsubscribe. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <p className="text-[#B0B0B0]">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="unsubscribe-page">
      <div className="w-full max-w-md p-8">
        <div className="bg-[#121212] border border-[rgba(255,255,255,0.12)] rounded-lg p-8 text-center">
          {error ? (
            <>
              <MailX size={40} className="mx-auto mb-4 text-[#FF3B30]" />
              <h1 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>
                Unsubscribe Error
              </h1>
              <p className="text-[#B0B0B0] text-sm">{error}</p>
            </>
          ) : done ? (
            <>
              <CheckCircle size={40} className="mx-auto mb-4 text-[#00FF99]" />
              <h1 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>
                Unsubscribed
              </h1>
              <p className="text-[#B0B0B0] text-sm">
                You have been unsubscribed from <strong className="text-white">{info?.list_name}</strong> by <strong className="text-white">{info?.business_name}</strong>.
              </p>
            </>
          ) : (
            <>
              <MailX size={40} className="mx-auto mb-4 text-[#FFB800]" />
              <h1 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Manrope' }}>
                Unsubscribe
              </h1>
              <p className="text-[#B0B0B0] text-sm mb-6">
                Are you sure you want to unsubscribe <strong className="text-white">{info?.contact_email}</strong> from <strong className="text-white">{info?.list_name}</strong> ({info?.business_name})?
              </p>
              <Button onClick={handleUnsubscribe} data-testid="confirm-unsubscribe-btn"
                className="w-full bg-[#FF3B30] text-white font-bold hover:bg-[#FF3B30]/80">
                Confirm Unsubscribe
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
